// 强类型配置定义
export type AppEnvironment = "development" | "production";

export interface AppConfig {
  baseUrl: string;
  mcpUrl: string;
  turnstileSiteKey: string;
  rpc: string;
  decimals: number;
  editorUrl: string;
  // 保留recaptchaKey用于向后兼容，但应逐步移除
  recaptchaKey?: string;
}

// 环境检测
export const environment: AppEnvironment = process.env.REACT_APP_ENV === "production" ? "production" : "development";

// 环境变量读取
const envTurnstileKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAByJ-WT7s4YYZC9g";
// const envTurnstileKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "3x00000000000000000000FF";

// 配置字典
const configs: Record<AppEnvironment, AppConfig> = {
  development: {
    baseUrl: "https://platform-staging.subscan.io",
    mcpUrl: "https://mcp-staging.subscan.io",
    recaptchaKey: "6LfE9CUrAAAAAH5slnUIIgX3IAfFQo5402cjz6NW",
    turnstileSiteKey: envTurnstileKey || "1x00000000000000000000AA", // 测试用公钥
    rpc: "wss://westend-rpc.polkadot.io",
    decimals: 12,
    editorUrl: "/lowcode/editor",
  },
  production: {
    baseUrl: "https://platform.subscan.io",
    mcpUrl: "https://mcp.subscan.io",
    recaptchaKey: "6Le2Bi8fAAAAAIbAg3BRh7GvZVcgaiuM56feSop8",
    turnstileSiteKey: envTurnstileKey, // 生产环境必须提供
    rpc: "wss://rpc.polkadot.io",
    decimals: 10,
    editorUrl: "/lowcode/editor",
  },
};

// 配置获取
const config = configs[environment];
if (!config) {
  throw new Error(`Invalid environment: ${environment}`);
}

// 数字格式化配置 - 业务相关，保持不变
export const BIGNUMBER_FMT = {
  prefix: "",
  decimalSeparator: ".",
  groupSeparator: ",",
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: " ",
  fractionGroupSize: 0,
  suffix: "",
};

// 操作符枚举
export enum Operator {
  OPERATOR_UNSPECIFIED = "OPERATOR_UNSPECIFIED", // Default value, invalid
  OPERATOR_EQUALS = "OPERATOR_EQUALS", // ==
  OPERATOR_NOT_EQUALS = "OPERATOR_NOT_EQUALS", // !=
  OPERATOR_GREATER_THAN = "OPERATOR_GREATER_THAN", // >
  OPERATOR_LESS_THAN = "OPERATOR_LESS_THAN", // <
  OPERATOR_GREATER_THAN_EQUAL = "OPERATOR_GREATER_THAN_EQUAL", // >=
  OPERATOR_LESS_THAN_EQUAL = "OPERATOR_LESS_THAN_EQUAL", // <=
  OPERATOR_CONTAINS = "OPERATOR_CONTAINS", // contains
  OPERATOR_NOT_CONTAINS = "OPERATOR_NOT_CONTAINS", // not contains
  OPERATOR_STARTS_WITH = "OPERATOR_STARTS_WITH", // starts with
  OPERATOR_ENDS_WITH = "OPERATOR_ENDS_WITH", // ends with
}

// 逻辑操作符枚举
export enum LogicalOperator {
  Logical_Operator_UNSPECIFIED = "Logical_Operator_UNSPECIFIED",
  Logical_Operator_And = "Logical_Operator_And",
  Logical_Operator_Or = "Logical_Operator_Or",
}

// 导出配置
export default config;
